<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="bk">
<h1 class="bk"><a class="page" id="pii"></a><a class="page" id="piii"></a>Cherubino’s Leap</h1>
<h1 class="bk1">In Search of the Enlightenment Moment</h1>
<p class="bkau">Richard Kramer</p>
<p class="bkpub">The University of Chicago Press</p>
<p class="bkpub1">Chicago and London</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-kramer-0003.vue?07c35283